import { getUrlForDomainInContext } from '@atlaskit/atlassian-context/get-url-for-domain-in-context';
import { isIsolatedCloud } from '@atlaskit/atlassian-context/is-isolated-cloud';
import { isolatedCloudDomain } from '@atlaskit/atlassian-context/isolated-cloud-domain';
import { addRovoParamsToUrl } from '@atlaskit/rovo-triggers/params';

/** Resolve the Atlassian Home base URL for the current environment/perimeter. */
const getHomeBaseUrl = (): string => {
	if (isIsolatedCloud()) {
		const homeUrl = getUrlForDomainInContext('home', 'prod');
		if (homeUrl) {
			return homeUrl;
		}

		const domain = isolatedCloudDomain();
		if (domain) {
			return `https://team.${domain}`;
		}
	}

	const { hostname } = window.location;
	if (
		hostname.includes('jira-dev.com') ||
		hostname.includes('.stg.atlassian.') ||
		hostname.startsWith('localhost')
	) {
		return 'https://home.stg.atlassian.com';
	}

	return 'https://home.atlassian.com';
};

export const buildHomeChatUrl = ({
	orgId,
	cloudId,
	query,
	conversationId,
}: {
	orgId?: string;
	cloudId?: string;
	query?: string;
	conversationId?: string;
}): string => {
	const base = getHomeBaseUrl();
	const path = orgId ? `${base}/o/${orgId}/chat` : `${base}/chat`;
	const trimmedQuery = query?.trim();

	return addRovoParamsToUrl(path, {
		pathway: 'chat',
		cloudId,
		prompt: trimmedQuery || undefined,
		conversationId,
	});
};
